import styled from 'styled-components'
import Chip from '@mui/material/Chip'
import { ItineraryStatus } from 'types'

type StatusChipProps = {
  status: ItineraryStatus
}

export const StatusChip = styled(Chip)<StatusChipProps>`
  color: ${(p) => p.theme.itinerary.status[p.status]};
  border-color: ${(p) => p.theme.itinerary.status[p.status]};
  font-weight: 600;
`

export default StatusChip
